import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var LoadPreviousIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M13.5 1.571C19.297 1.571 24 6.24 24 12s-4.703 10.429-10.5 10.429c-1.728 0-3.398-.416-4.895-1.2a1 1 0 01.929-1.772 8.515 8.515 0 003.966.972c4.696 0 8.5-3.776 8.5-8.429 0-4.653-3.804-8.429-8.5-8.429-4.566 0-8.29 3.57-8.491 8.046l1.273-1.313A1 1 0 017.8 11.6l-.082.096-3 3.095a1 1 0 01-1.341.087l-.095-.087-3-3.095a1 1 0 011.343-1.477l.093.085 1.288 1.328c.195-5.59 4.82-10.06 10.494-10.06zm-.5 4.19a1 1 0 011 1v5.287h4a1 1 0 010 2h-5a1 1 0 01-1-1V6.762a1 1 0 011-1z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
LoadPreviousIcon.isCarinaIcon = true;
export default LoadPreviousIcon;
